const reportWebVitals = (onPerfEntry?: (metric: unknown) => void): void => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry as never);
      getFID(onPerfEntry as never);
      getFCP(onPerfEntry as never);
      getLCP(onPerfEntry as never);
      getTTFB(onPerfEntry as never);
    });
  }
};

export default reportWebVitals;
